export function Wordmark({ light, size = "text-2xl", suffix, testId = "logo-v" }) {
  return (
    <span className={`${size} font-semibold leading-none tracking-[-0.045em] ${light ? "text-primary-foreground" : "text-primary"}`}>
      <span data-testid={testId} className={light ? "text-[#7FB2FF]" : "text-[#2F6EEA]"}>V</span>istolane
      {suffix && <span className="ml-1.5 font-medium normal-case text-body">{suffix}</span>}
    </span>
  );
}

export function Brand({ light, word = "istolane" }) {
  // Inline mention inside running text: inherits the surrounding font size and line-height, set in the wordmark style.
  return <span className={`font-semibold tracking-[-0.045em] ${light ? "text-primary-foreground" : "text-primary"}`}><span data-testid="brand-v" className={light ? "text-[#7FB2FF]" : "text-[#2F6EEA]"}>V</span>{word}</span>;
}

function brandify(text, light) {
  const parts = text.split(/(vistolane|\bVIMS\b)/i);
  if (parts.length === 1) return text;
  // One wrapper node, so flex parents (accordion triggers, buttons) do not spread the fragments apart.
  return <span>{parts.map((part, i) => (/^vistolane$/i.test(part) ? <Brand key={`brand-${i}`} light={light} /> : /^VIMS$/i.test(part) ? <Brand key={`brand-${i}`} light={light} word="IMS" /> : part))}</span>;
}

export function BrandText({ children, light }) {
  if (Array.isArray(children)) return children.map((c, i) => (typeof c === "string" ? <span key={i}>{brandify(c, light)}</span> : c));
  if (typeof children !== "string") return children;
  return brandify(children, light);
}
